const light = {
  colors: {
    BG1: '#F5F5F5',
    BG2: '#FFF',

    IC1: '#333',
    IC2: '#FFF',

    TEXT1: '#333',
    TEXT2: '#FFF',
    TEXT3: '#CCC',
    TEXT4: '#666',

    COLOR_1: '#171717',
    COLOR_2: '#171717',

    BTNBG: '#333',
    BTNLABEL: '#FFF',
    BTNBGH: '#000',
    BTNLABELH: '#FFF',

    LIGHT1: 'rgba(0,0,0,0.05)',
    LIGHT2: 'rgba(255,255,255,0.05)',
    LIGHT3: 'rgba(0,0,0,0.08)',
    LIGHT4: 'rgba(0,0,0,0.02)',
    LIGHT5: '#FFF',
    LIGHT6: 'rgba(0,0,0,0.01)',
    LIGHT7: 'rgba(0,0,0,0.06)',

    SHADOW: 'rgba(0,0,0,0.02)',

    BORDER: 'rgba(0,0,0,0.1)',

    ORANGE: '#f26c17',
    GREEN: '#1ead1e',
    GREENDARK: 'rgb(19,226,123,0.4)',

    BAR1: 'rgba(0,0,0,0.1)',
    BAR2: 'rgba(0,0,0,0.1)',
    BAR3: 'rgba(0,0,0,0.1)',

    MENU_SUBACTIVE: '#f26c17',
    MENU_ACTIVE: '#f26c17'
  },
};

export default light;
